import "./Home.module.css";
import PureDetailHeader from "@/reusable_sections/Header";
import PrecisionCleaningProfessionalResults from "./sections/PrecisionCleaningProfessionalResults";
import ProudlyServingCentralTexas from "./sections/ProudlyServingCentralTexas";
import PureDetailFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <PureDetailHeader />
      <PrecisionCleaningProfessionalResults />
      <ProudlyServingCentralTexas />
      <PureDetailFooter />
    </div>;
}